// Funding round enum verified against Crustdata's CompanyDB
// /screener/companydb/autocomplete on ``last_funding_round_type``.
//
// The portal previously shipped a 14-value list including ``venture``
// and ``crowdfunding`` which aren't in the canonical enum at all.
// Replaced with the verified 22-value set + a UI-only "Bootstrapped"
// pseudo-value that maps to ``crunchbase_total_investment_usd <= 0``.

export interface FundingRoundOption {
  /** Canonical Crustdata wire value (snake_case). */
  value: string;
  /** UI display label. */
  label: string;
  /** Visual grouping in the filter dropdown. */
  group: 'Pre-IPO' | 'Post-IPO' | 'Other';
}

export const FUNDING_ROUND_OPTIONS: FundingRoundOption[] = [
  // Pre-IPO equity rounds, ordered by stage
  { value: 'pre_seed', label: 'Pre-Seed', group: 'Pre-IPO' },
  { value: 'seed', label: 'Seed', group: 'Pre-IPO' },
  { value: 'series_a', label: 'Series A', group: 'Pre-IPO' },
  { value: 'series_b', label: 'Series B', group: 'Pre-IPO' },
  { value: 'series_c', label: 'Series C', group: 'Pre-IPO' },
  { value: 'series_d', label: 'Series D', group: 'Pre-IPO' },
  { value: 'series_e', label: 'Series E', group: 'Pre-IPO' },
  { value: 'series_f', label: 'Series F', group: 'Pre-IPO' },
  { value: 'series_g', label: 'Series G', group: 'Pre-IPO' },
  { value: 'series_h', label: 'Series H', group: 'Pre-IPO' },
  { value: 'series_unknown', label: 'Series Unknown', group: 'Pre-IPO' },
  // Post-IPO instruments
  { value: 'post_ipo_equity', label: 'Post-IPO Equity', group: 'Post-IPO' },
  { value: 'post_ipo_debt', label: 'Post-IPO Debt', group: 'Post-IPO' },
  {
    value: 'post_ipo_secondary',
    label: 'Post-IPO Secondary',
    group: 'Post-IPO',
  },
  // Other / non-traditional
  { value: 'angel', label: 'Angel', group: 'Other' },
  { value: 'convertible_note', label: 'Convertible Note', group: 'Other' },
  { value: 'corporate_round', label: 'Corporate Round', group: 'Other' },
  { value: 'debt_financing', label: 'Debt Financing', group: 'Other' },
  { value: 'private_equity', label: 'Private Equity', group: 'Other' },
  { value: 'secondary_market', label: 'Secondary Market', group: 'Other' },
  {
    value: 'non_equity_assistance',
    label: 'Non-Equity Assistance',
    group: 'Other',
  },
  { value: 'grant', label: 'Grant', group: 'Other' },
  { value: 'undisclosed', label: 'Undisclosed', group: 'Other' },
];

export const FUNDING_ROUND_VALUES: string[] = FUNDING_ROUND_OPTIONS.map(
  (o) => o.value
);
